import React from 'react';
import { Link } from 'react-router-dom';
import './ISO14001.css';

const ISO14001 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 14001 Environmental Management System</h1>
            <h2 className="page-subtitle">ISO 14001 Environmental Management System: Responsibility for Protecting Nature</h2>
            <div className="page-text-content">
              <p>
                NQC (Nova Quality Certification Agency) assists organizations in managing environmental 
                impacts with the ISO 14001 certificate, promoting environmentally conscious business 
                processes, sustainability, and environmental leadership.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 14001 Environmental Management System?</h2>
            <div className="page-text-content">
              <p>
                ISO 14001 is a standard for an environmental management system (EMS) used to evaluate, 
                control, and continuously improve environmental performance, reduce impacts, use natural 
                resources effectively, and establish sustainable environmental policies.
              </p>
              <p>
                ISO 14001 addresses environmental management in an integrated manner, encourages 
                organizations to fulfill environmental responsibilities, and includes principles for 
                best practices.
              </p>
              <p>
                The core elements of the standard include: defining environmental policy, assessing 
                environmental impacts, setting environmental objectives, implementing and operating 
                procedures, monitoring and measuring performance, evaluating, and continuously improving 
                processes. ISO 14001 provides a framework for enhancing environmental performance and 
                managing environmental risks.
              </p>
              <p>
                Obtaining the ISO 14001 certificate demonstrates a properly established, operated, and 
                maintained EMS, guiding organizations in fulfilling environmental responsibilities and 
                symbolizing reliable environmental performance to customers and stakeholders.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">The Key Elements of ISO 14001 Standards:</h2>
            <div className="elements-list">
              <div className="element-item">
                <h3 className="element-title">1. Environmental Policy</h3>
                <p className="element-description">
                  The organization defines its environmental goals and commitments. This policy guides 
                  the organization in achieving its environmental objectives.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">2. Planning</h3>
                <p className="element-description">
                  Focuses on identifying environmental impacts, legal requirements, and setting 
                  objectives to address environmental challenges effectively.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">3. Implementation and Operation</h3>
                <p className="element-description">
                  Covers implementing policies, training employees, and allocating resources to ensure 
                  effective environmental management.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">4. Monitoring and Measuring</h3>
                <p className="element-description">
                  Involves evaluating environmental performance against objectives and tracking progress 
                  toward environmental goals.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">5. Evaluation and Improvement</h3>
                <p className="element-description">
                  Details management review, performance evaluation, and continuous improvement processes 
                  to enhance environmental performance over time.
                </p>
              </div>
            </div>
            <div className="page-text-content">
              <p>
                ISO 14001 provides a framework for organizations to understand environmental impacts, 
                act responsibly, and enhance sustainability through continuous improvement of their 
                environmental management system.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Benefits of ISO 14001 Certification:</h2>
            <div className="benefits-list">
              <div className="benefit-item">
                <h3 className="benefit-title">1. Legal Compliance</h3>
                <p className="benefit-description">
                  Ensures adherence to environmental legal requirements and helps organizations stay 
                  compliant with regulations.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">2. Image and Competitive Advantage</h3>
                <p className="benefit-description">
                  Builds trust by highlighting environmental responsibilities and demonstrates commitment 
                  to sustainability, giving businesses a competitive edge.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">3. Increased Efficiency</h3>
                <p className="benefit-description">
                  Improves business processes and resource use, leading to more efficient operations 
                  and reduced waste.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">4. Cost Savings</h3>
                <p className="benefit-description">
                  Achieves savings through efficient use of energy, water, and other resources, 
                  reducing operational costs.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">5. Sustainability</h3>
                <p className="benefit-description">
                  Promotes actions aligned with environmental sustainability principles, contributing 
                  to long-term environmental protection.
                </p>
              </div>
            </div>
            <div className="page-text-content">
              <p>
                ISO 14001 is a crucial tool for environmentally conscious organizations aiming to 
                improve performance, reduce environmental impact, and demonstrate commitment to 
                sustainable business practices.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO14001;

